import React, { useState, useEffect } from "react";
import "./rules.css";
import { Link, useNavigate } from "react-router-dom";
import defaultLogo from "../../img/logo.png";
import howToPlayIcon from "../../img/icons.png";
import { useBrandCtaVars } from "../../hooks/useBrandCtaVars";

/** Shown when `userData.rules` is missing or empty */
const DEFAULT_RULES = [
  "Hey… I'm stuck. Help me get out?",
  "Drag the blocks around to clear my path",
  "Tap or hover on a block, I'll show you arrows so you know how it moves",
  "Some blocks slide left and right, some go up and down, you'll figure it out",
  "Just make space for me to reach the exit"
];

function parseRules(val) {
  if (Array.isArray(val)) return val.filter(Boolean);
  if (typeof val === "string") {
    try {
      const p = JSON.parse(val);
      return Array.isArray(p) ? p.filter(Boolean) : [];
    } catch {
      return [];
    }
  }
  return [];
}

function Rules({ updateHeader }) {
  const navigate = useNavigate();
  const [topLogo, setTopLogo] = useState(defaultLogo);
  const [userData, setUserData] = useState(null);
  const [rules, setRules] = useState(DEFAULT_RULES);
  const [textcolor, Setcolorcode] = useState(null);

  useEffect(() => {
    const storedSession = sessionStorage.getItem("userData");
    if (!storedSession) {
      navigate("/login");
      return;
    }

   
    // eslint-disable-next-line react-hooks/exhaustive-deps -- updateHeader identity varies by parent
  }, [navigate]);

  
  useEffect(() => {
    updateHeader({
      backButtonRedirect: "/login?save=true",
      // ...(companyLogo ? { imageUrl: companyLogo } : {}),
    });
  }, []);

  const { style: ctaVars, themed: ctaThemed } = useBrandCtaVars(userData, topLogo);

  const titleColor = textcolor || undefined;

  return (
    <div className="rules-page">
      <main className="rules-page__main">

        <h1 className="rules-page__title" style={{ color: titleColor }} id="introtext">
          <img src={howToPlayIcon} alt="" className="rules-page__title-icon" aria-hidden="true" />
          <span>How to Play</span>
        </h1>
        
        <div className="rules-page__box">
          <ul
            className="rules-page__card"
            style={{ "--rules-bullet-icon": `url(${howToPlayIcon})` }}
          >
            {rules.map((rule, index) => (
              <li className="rules-page__rule" key={index}>
                {rule || "N/A"}
              </li>
            ))}
          </ul>

          <div className="rules-page__actions">
            <Link
              to="/game"
              className={ctaThemed ? "begin-play-btn begin-play-btn--themed" : "begin-play-btn"}
              style={ctaThemed ? ctaVars : undefined}
            >
              let's get out of here
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Rules;
